<template>
    <section class="features-section">
      <h1 class="section-title">Features</h1>
      <div class="features-list">
        <div
          v-for="(item, i) in features"
          :key="i"
          class="feature-row"
          :class="{ reverse: i % 2 !== 0 }"
        >
          <div class="feature-image">
            <img :src="item.icon" :alt="item.title" />
          </div>
          <div class="feature-text">
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: "FeaturesSection",
    data() {
      return {
        features: [
          {
            title: "Exklusive promo",
            description: "Homepage featuring highlighted content and latest news.",
            icon: require("@/assets/s7.png"),
          },
          {
            title: "Recommended Vod on demand",
            description: "Highlighting recommended movies and series on the homepage.",
            icon: require("@/assets/s8.png"),
          },
          {
            title: "Video on demand Studios",
            description: "Grouping the video club content into additional categories and studios.",
            icon: require("@/assets/s12.png"),
          },
          {
            title: "User frendly EPG",
            description: "Choose missed shows from a modern TV interface.",
            icon: require("@/assets/s11.png"),
          },
          {
            title: "Modern Video on demand",
            description: "Modern and fluid VOD interface for fast and easy browsing of movies and series.",
            icon: require("@/assets/s15.png"),
          },
          {
            title: "VOD Details Overview",
            description: "Detailed overview of selected movies and series.",
            icon: require("@/assets/s14.png"),
          },

          {
            title: "Content manager",
            description: "Customize the app components to suit your preferences.",
            icon: require("@/assets/s13.png"),
          },
         
        ],
      };
    },
  };
  </script>
  
  <style scoped>
  .features-section {
    background: #000;
    color: white;
    padding: 60px 20px;
    text-align: center;
  }
  
  .section-title {
    font-size: 2.5rem;
    margin-bottom: 60px;
  }
  
  .features-list {
    display: flex;
    flex-direction: column;
    gap: 80px;
    max-width: 1600px;
    margin: auto;
  }
  
  .feature-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 50px;
    flex-wrap: wrap;
  }
  
  .feature-row.reverse {
    flex-direction: row-reverse;
  }
  
  .feature-image img {
    width: 650px;
    max-width: 100%;
    border-radius: 10px;
    box-shadow:2px 2px 5px black;
    filter: drop-shadow(0 0 150px #0f3b99);
  }
  
  .feature-text {
    max-width: 800px;
    text-align: left;
  }
  
  .feature-text h3 {
    font-size: 1.7rem;
    margin-bottom: 10px;
    color: #00ccff;
  }
  
  .feature-text p {
    font-size: 1.1rem;
    color: white;
  }
  </style>
  